<template>
  <v-dialog v-model="dialog"  persistent scrollable max-width="600px" style="z-index: 999">
    <v-card>
      <v-card-title primary-title>
        <span class="headline">Edição de Usuario</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form">
            <v-layout row justify-space-between wrap>
              <v-flex xs12>
                <v-text-field ref="autofocus" validate-on-blur :rules="phoneRule('Telefone', 0)" v-model="editedItem.phone" mask="(##) #####-####" label="Telefone*"></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <small>* Campos obrigatórios</small>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <small>Os dados preenchidos serão salvos no cadastro da usuario</small>
        <v-spacer></v-spacer>
        <v-btn class="mx-2" color="primary darken-2" @click="save">Salvar</v-btn>
        <v-btn class="mx-2" @click="close">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import rules from './../../mixin/rules'
  export default {
    mixins: [rules],
    name: 'PUserEdit',
    data: () => ({
      editedItem: {},
      dialog: false
    }),
    mounted () {
      this.editedItem = Object.assign(this.editedItem, this.$auth.user())
    },
    methods: {
      close () {
        this.$emit('close')
        this.dialog = false
      },
      open () {
        this.dialog = true
        if (this.$refs.autofocus) {
          this.$nextTick(() => this.$refs.autofocus.focus())
        }
      },
      save () {
        if (!this.$refs.form.validate()) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        this.$store.commit('loader/change_dialog', true)
        this.$http.put(`api/users/${this.editedItem.id}`, this.editedItem).then(
          (res) => {
            this.$auth.user(res.body)
            this.dialog = false
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Registro de ' + res.body.id_text +
              ' editado com sucesso!',
              color: 'success',
              dialog: true
            })
            this.$emit('onSave')
          },
          err => {
            console.log(err)
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível incluir o registro, reporte o erro.',
              color: 'error',
              dialog: true
            })
          }
        )
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/shared/PUserEdit.vue